"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var RemotePasswordValidator = /** @class */ (function () {
    function RemotePasswordValidator(minValidScore) {
        if (minValidScore === void 0) { minValidScore = 3; }
        var _this = this;
        this.checkPassword = function (password) {
            mobx_1.transaction(function () {
                _this.passwordStrength = {};
                if (!password) {
                    return;
                }
                _this.isCheckingPassword = true;
                window.__sdk__.utils.passwordStrength(password)
                    .then(function (res) { return _this.onCheckPasswordComplete(res); })
                    .catch(function () { return _this.onCheckPasswordError(); });
            });
        };
        this.reset();
        this.minValidScore = minValidScore;
    }
    RemotePasswordValidator.prototype.reset = function () {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isCheckingPassword = false;
            _this.passwordStrength = {};
        });
    };
    RemotePasswordValidator.prototype.setCheckState = function (state) {
        this.isCheckingPassword = state;
    };
    RemotePasswordValidator.prototype.onCheckPasswordComplete = function (res) {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isCheckingPassword = false;
            _this.passwordStrength = res;
        });
    };
    RemotePasswordValidator.prototype.onCheckPasswordError = function () {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isCheckingPassword = false;
            _this.passwordStrength = {};
        });
    };
    Object.defineProperty(RemotePasswordValidator.prototype, "passwordScore", {
        get: function () {
            return this.passwordStrength && !isNaN(this.passwordStrength.score)
                ? this.passwordStrength.score
                : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RemotePasswordValidator.prototype, "isValid", {
        get: function () {
            return this.passwordScore >= this.minValidScore;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], RemotePasswordValidator.prototype, "isCheckingPassword", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], RemotePasswordValidator.prototype, "passwordStrength", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], RemotePasswordValidator.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], RemotePasswordValidator.prototype, "setCheckState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], RemotePasswordValidator.prototype, "checkPassword", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], RemotePasswordValidator.prototype, "onCheckPasswordComplete", null);
    tslib_1.__decorate([
        mobx_1.action
    ], RemotePasswordValidator.prototype, "onCheckPasswordError", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], RemotePasswordValidator.prototype, "passwordScore", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], RemotePasswordValidator.prototype, "isValid", null);
    return RemotePasswordValidator;
}());
exports.default = RemotePasswordValidator;
